export const featuresData = {
  en: [
    {
      id: 'safety',
      title: 'Safety First',
      description: 'Integrated safety protocols, hazard identification, and emergency response procedures for all operations.',
      icon: 'shield-check'
    },
    {
      id: 'compliance',
      title: 'Full Compliance',
      description: 'Automated compliance tracking, documentation, and reporting to meet all regulatory requirements.',
      icon: 'document-check'
    },
    {
      id: 'sustainability',
      title: 'Sustainable Practices',
      description: 'Environmentally responsible cultivation methods with carbon footprint monitoring and reduction targets.',
      icon: 'leaf'
    },
    {
      id: 'training',
      title: 'Comprehensive Training',
      description: 'Interactive training modules, simulation exercises, and continuous learning programs for all staff.',
      icon: 'academic-cap'
    },
    {
      id: 'tracking',
      title: 'Real-time Tracking',
      description: 'QR code-based tracking system for complete traceability from cultivation to export.',
      icon: 'qrcode'
    },
    {
      id: 'analytics',
      title: 'Data Analytics',
      description: 'Advanced analytics and reporting tools for performance monitoring and continuous improvement.',
      icon: 'chart-bar'
    }
  ],
  th: [
    {
      id: 'safety',
      title: 'ความปลอดภัยเป็นอันดับแรก',
      description: 'โปรโตคอลความปลอดภัยแบบบูรณาการ การระบุอันตราย และขั้นตอนการตอบสนองฉุกเฉินสำหรับการดำเนินงานทั้งหมด',
      icon: 'shield-check'
    },
    {
      id: 'compliance',
      title: 'การปฏิบัติตามข้อกำหนดอย่างสมบูรณ์',
      description: 'การติดตามการปฏิบัติตามข้อกำหนด อ้างอิง และรายงานอัตโนมัติเพื่อให้เป็นไปตามข้อกำหนดของกฎระเบียบทั้งหมด',
      icon: 'document-check'
    },
    {
      id: 'sustainability',
      title: 'แนวทางปฏิบัติที่ยั่งยืน',
      description: 'วิธีการปลูกที่มีความรับผิดชอบต่อสิ่งแวดล้อมด้วยการตรวจสอบและการลดการปล่อยก๊าซคาร์บอน',
      icon: 'leaf'
    },
    {
      id: 'training',
      title: 'การฝึกอบรมอย่างครอบคลุม',
      description: 'โมดูลการฝึกอบรมแบบโต้ตอบ การจำลองแบบฝึกซ้อม และโปรแกรมการเรียนรู้อย่างต่อเนื่องสำหรับพนักงานทุกคน',
      icon: 'academic-cap'
    },
    {
      id: 'tracking',
      title: 'การติดตามแบบเรียลไทม์',
      description: 'ระบบการติดตามแบบ QR code สำหรับการติดตามอย่างสมบูรณ์ตั้งแต่การปลูกจนถึงการส่งออก',
      icon: 'qrcode'
    },
    {
      id: 'analytics',
      title: 'การวิเคราะห์ข้อมูล',
      description: 'เครื่องมือการวิเคราะห์และรายงานขั้นสูงสำหรับการตรวจสอบประสิทธิภาพและการปรับปรุงอย่างต่อเนื่อง',
      icon: 'chart-bar'
    }
  ]
};
